import { Injectable } from '@angular/core';
import { API_account_managers_list } from '@core/api/paths';
import { ApiService } from '@core/http';

import { Observable } from 'rxjs';
import { TAccountManagerList } from 'src/app/project/view-models/account-manager-list.model';

@Injectable({
  providedIn: 'root',
})
export class AccountManagerApiProviderService {
  constructor(private apiService: ApiService) {}

  fetchAccountManagerList(): Observable<TAccountManagerList> {
    const url = API_account_managers_list();

    return this.apiService.get<TAccountManagerList>(url);
  }
}
